import { render, staticRenderFns } from "./OrderDownload.vue?vue&type=template&id=88143c76&scoped=true&"
import script from "./OrderDownload.vue?vue&type=script&lang=js&"
export * from "./OrderDownload.vue?vue&type=script&lang=js&"
import style0 from "./OrderDownload.vue?vue&type=style&index=0&id=88143c76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88143c76",
  null
  
)

export default component.exports